module.exports = __webpack_public_path__ + "img/img25.03147f84.jpg";